import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a96de468&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a96de468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96de468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a96de468')) {
      api.createRecord('a96de468', component.options)
    } else {
      api.reload('a96de468', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a96de468&scoped=true&", function () {
      api.rerender('a96de468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/finance/components/account-history-table/index.vue"
export default component.exports